import React, { useEffect, useState, useRef } from "react";
import { Button as ReactScrollButton } from "react-scroll";

const useIsiSection = () => {
  const isiAnchorRef = useRef();
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
        } else if (entry.boundingClientRect.y < 0) {
          setIsInView(true);
        } else {
          setIsInView(false);
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.5,
      }
    );
    if (isiAnchorRef.current) {
      observer.observe(isiAnchorRef.current);
    }
  }, [isiAnchorRef]);

  const ISIScrollButton = ({ onClick, children }) => (
    <ReactScrollButton
      to="isi-section"
      onClick={onClick}
      smooth={true}
      offset={-100}
      duration={1000}
    >
      {children}
    </ReactScrollButton>
  );

  return {
    isiAnchorRef,
    isInView,
    ISIScrollButton,
  };
};

export default useIsiSection;
